import { Add, Edit, Visibility } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
// import CustomModal from "../../../../Shared/CustomModal";
// import CustomSelect from "Shared/CustomSelect";
// import div from "Shared/div";
// import axiosInstance from "Config/axio.config";
// import { variantListByProductIdFn } from "../../../../Services/Inventory/VariantListByProductId";
import CustomButton from "../../../shared/CustomButton2";
import CustomInput from "../../../shared/CustomInput2";
import CustomModal from "../../../shared/CustomModal";
import DownloadIcon from "@mui/icons-material/Download";
import CustomSelect from "../../../shared/CustomSelect";
import { CustomIconButton } from "../../../shared/CustomIconButton";
import axiosInstance, { baseUrl } from "../../../config/axios";
import { variantListByProductIdFn } from "../../../Services/Variant/Specification";

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const AddSpecification = ({ variant, className }) => {
  const [open, setOpen] = useState(false);
  const [specsTypeList, setSpecsTypeList] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [specifications, setSpecifications] = useState("");
  const [enableEdit, setEnableEdit] = useState("");
  const [copySpecs, setCopySpecs] = useState("");

  const [open1, setOpen1] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState();

  const updaloadFile = () => {
    const formData = new FormData();
    formData.append("file", file);

    axiosInstance
      .post(
        "api/admin/upload-product-variant-specificaton-value-by-excel-admin-api/",
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentage =
              (progressEvent.loaded / progressEvent.total) * 100;
            setProgress(percentage);
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          toast.success(response?.data?.message);
          setUploading(true);
          handleModalClose1();
          setProgress(100);
          specsType();
          // setCountData(response?.data);
        } else {
          toast.warn(response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error?.message);
        toast.error(error.message);
      });
  };
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
    specsType();
  };

  const specsType = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `api/admin/product-variant-specification-admin-api/?product_variant_id=${variant?.id}`
      );
      setIsLoading(false);
      setSpecsTypeList(response?.data?.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const { data: variants } = useQuery(
    ["variantListById"],
    () => variantListByProductIdFn({ product_id: variant?.product }),
    { enabled: variant && open ? true : false }
  );

  const handleAdd = async (specsId, valueId, value) => {
    const reqBody = {
      product_variant_id: variant?.id,
      specification_id: specsId,
      value: specifications !== "" ? specifications || value : "--",
      value_id: valueId,
    };
    try {
      const response = !valueId
        ? await axiosInstance.post(
            `api/admin/product-variant-specification-admin-api/`,
            reqBody
          )
        : await axiosInstance.put(
            `api/admin/product-variant-specification-admin-api/`,
            reqBody
          );

      specsType();
      setEnableEdit("");
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCopy = async () => {
    const reqBody = {
      copy_to_variant_id: variant?.id,
      copy_from_variant_id: copySpecs,
      product_id: variant?.product,
    };
    try {
      const response = await axiosInstance.post(
        `api/admin/copy-product-variant-specification-admin-api/`,
        reqBody
      );
      if (response) {
        toast.success(response.data.message);
        specsType();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const downloadSample = async () => {
    // const reqBody = ;
    // try {
    //   const response = await axiosInstance.post(
    //     `api/admin/generate-product-variant-specification-value-sample-admin-api/`,
    //     reqBody
    //   );
    try {
      const response = await fetch(
        `${baseUrl}api/admin/generate-product-variant-specification-value-sample-admin-api/`,
        {
          method: "POST",
          headers: {
            // Authorization: "Token" + localStorage.getItem("Token"),
            "Content-Type": "application/json",
            Token: localStorage.getItem("Token"),
          },
          body: JSON.stringify({
            product_variant_id: variant?.id,
          }),
        }
      );
      if (response) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "variant_specification_data.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
        // specsType();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleEnableEdit = (type) => {
    setEnableEdit(type?.specification_id);
    setSpecifications(type?.value);
  };
  const handleModalClose1 = () => {
    setFile(null);
    setUploading(false);
    setProgress(0);
    // inventoryData();
    setOpen1(false);
  };
  return (
    <>
      {/* <CustomIconButton color="primary" onClick={handleOpen}> */}
      <Visibility onClick={handleOpen} className="!text-green-700" />
      {/* </CustomIconButton> */}
      <CustomModal
        open={open}
        onClose={handleClose}
        className="w-[75%] lg:!w-2/5 h-3/5  overflow-y-auto"
      >
        <div className="flex flex-col  !pb-10 !mb-5 justify-center gap-5">
          <span className="text-xl font-semibold text-center">
            Manage Specifications
          </span>
          <div
            className="text-lg font-bold flex justify-between items-center  p-3 !shadow rounded-lg
        !bg-slate-100  border !border-slate-500 !border-opacity-20"
          >
            <span> Product Variant :{variant.product_name}</span>
            <Button
              variant="outlined"
              size="small"
              color="warning"
              className="!text-xs !p-1 "
              startIcon={<Add />}
              onClick={() => {
                setOpen1(true);
              }}
              // onClick={downloadSample}
            >
              Upload Excel
            </Button>
          </div>
          <div
            className="flex items-center !w-full justify-between gap-4 font-bold  p-3 !shadow rounded-lg
        !bg-slate-100  border !border-slate-500 !border-opacity-20"
          >
            <span className="flex items-center !w-[85%]  gap-2">
              Copy Specifications From :
              <Select
                placeholder="Select Variant"
                value={copySpecs}
                className="!w-[60%] !font-semibold !p-0 !h-12"
                onChange={(e) => setCopySpecs(e.target.value)}
              >
                {variants?.data?.data?.map((item) => {
                  return <MenuItem value={item.id}>{item.variant}</MenuItem>;
                })}
              </Select>
            </span>
            <CustomButton
              variant="contained"
              className="!text-white !bg-orange-700 hover:!bg-orange-800"
              onClick={() => handleCopy()}
            >
              Confirm
            </CustomButton>
          </div>
          <div className="flex flex-col w-full gap-5">
            <TableContainer>
              <Table
                className=" !p-3 !shadow !rounded-lg !overflow-x-scroll
        !bg-slate-100  !border !border-slate-500 !border-opacity-20 "
              >
                <TableHead className="!rounded-lg">
                  <TableRow className="!whitespace-nowrap !rounded-lg">
                    <TableCell className="!border-r !w-[10%] text-center  !whitespace-nowrap !font-bold  !border-slate-600 !border-opacity-50">
                      S. No.
                    </TableCell>
                    <TableCell className="!border-r !w-[20%] text-center  !font-bold !border-slate-600 !border-opacity-50">
                      Specification Type
                    </TableCell>
                    <TableCell className="!border-r !w-[50%] text-center  !font-bold !border-slate-600 !border-opacity-50">
                      Specification Value
                    </TableCell>
                    <TableCell className="!border-r !w-[20%] text-center  !font-bold !border-slate-600 !border-opacity-50">
                      Add/Update
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading
                    ? [1, 2, 3, 4, 5, 6, 7]?.map(() => {
                        return (
                          <TableRow>
                            <TableCell>
                              <Skeleton />
                            </TableCell>
                            <TableCell>
                              <Skeleton />
                            </TableCell>
                            <TableCell>
                              <Skeleton />
                            </TableCell>
                            <TableCell>
                              <Skeleton />
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : specsTypeList?.map((type, index) => {
                        // [1, 2, 3]?.map((type, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell className="border-r !w-[10%] !text-center !font-bold last:!border-none !border-slate-600 !border-opacity-30">
                              {index + 1}
                            </TableCell>
                            <TableCell className="border-r !w-[20%] !text-center !font-bold !border-slate-600 !border-opacity-30">
                              {/* {type} */}
                              {type.specification_value}
                            </TableCell>
                            {/* <TableCell className="border-r !text-center !font-bold !border-slate-600 !border-opacity-30">
                              <CustomInput
                                defaultValue={type.value || ""}
                                className="!w-full"
                                value={specifications}
                                placeholder="Specification Value"
                                onChange={(event) =>
                                  setSpecifications(event.target.value)
                                }
                              />
                            </TableCell> */}
                            {/* <TableCell className="border-r !font-bold !border-slate-600 !border-opacity-30 !text-center">
                              <IconButton className="!border-2">
                                <Add />
                              </IconButton>
                            </TableCell> */}
                            <TableCell className="border-r !w-[20%] !font-bold !border-slate-600 !border-opacity-30">
                              <div className="!max-w-[18rem]">
                                {" "}
                                {enableEdit !== type.specification_id ? (
                                  type.value !== "" ? (
                                    <span className="flex flex-wrap ">
                                      {" "}
                                      {type.value}
                                    </span>
                                  ) : (
                                    "--"
                                  )
                                ) : (
                                  <CustomInput
                                    defaultValue={type.value || ""}
                                    className="!w-full"
                                    value={specifications}
                                    placeholder="Specification Value"
                                    onChange={(event) =>
                                      setSpecifications(event.target.value)
                                    }
                                  />
                                )}
                              </div>
                            </TableCell>
                            <TableCell className="!font-bold !w-[20%] !text-center">
                              {type.value_id ? (
                                <IconButton
                                  className="!border-2"
                                  onClick={() => {
                                    enableEdit === type.specification_id
                                      ? handleAdd(
                                          type?.specification_id,
                                          type?.value_id,
                                          type?.value
                                        )
                                      : handleEnableEdit(type);
                                  }}
                                >
                                  <Edit />
                                </IconButton>
                              ) : (
                                <IconButton
                                  className="!border-2"
                                  onClick={() => {
                                    enableEdit === type.specification_id
                                      ? handleAdd(type?.specification_id)
                                      : handleEnableEdit(type);
                                  }}
                                >
                                  <Add />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </CustomModal>
      <Modal
        open={open1}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{ ...style1 }}
          className="rounded-2xl !border-0 !h-[40vh] overflow-auto"
        >
          <div
            id="child-modal-title "
            className="!text-black !underline !font-bold !pb-3 !text-center !text-xl"
          >
            Variant Specification Upload By Excel
          </div>
          <div
            className="relative float-right px-2 font-bold text-black rounded-sm cursor-pointer bottom-16 bg-slate-300 left-6"
            onClick={handleModalClose1}
          >
            x
          </div>

          <div className="flex gap-x-3 mt-7">
            <div className="font-bold text-gray-900">Download Sample</div>
            <div>
              <Button
                variant="contained"
                color="primary"
                className="!bg-blue-500"
                size="small"
                onClick={downloadSample}
              >
                Download <DownloadIcon />
              </Button>
            </div>
          </div>
          <div className="flex gap-x-3">
            <TextField
              size="small"
              id="outlined-basic"
              type="file"
              className="!w-[100%] !mt-3"
              onChange={handleFileChange}
            />
            <Button
              onClick={updaloadFile}
              disabled={uploading === true ? "" : uploading}
              variant="contained"
              type="submit"
              color="success"
              className="!py-2 !px-5 !font-bold !mt-3 !float-right"
            >
              {uploading ? "Uploaded" : "Upload"}
            </Button>
          </div>

          {uploading && (
            <div>
              <progress value={progress} max="100" />
              <span className="text-green-500 ">{Math.round(progress)}%</span>
            </div>
          )}
          {/* <br />
          <table className="table w-full">
            <thead>
              <tr>
                <th>Total Count</th>
                <th>Create Count</th>
                <th>Update Count</th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center text-green-500">
                <th>{countData?.total_data_count} </th>
                <th>{countData?.created_data_count} </th>
                <th>{countData?.updated_data_count} </th>
              </tr>
            </tbody>
          </table> */}
        </Box>
      </Modal>
    </>
  );
};

export default AddSpecification;
